module.exports = __webpack_public_path__ + "static/media/USD.d233fdc8.png";